import * as GameTypes from 'types/game.types';

const getDefaultStats = () : GameTypes.LocalStats => ({
    score: 0,
    rounds: 0
})

const getRandomStats = () : GameTypes.LocalStats => ({
    score: Phaser.Math.Between(100, 10000),
    rounds: Phaser.Math.Between(10, 500)
})

export {
    getDefaultStats,
    getRandomStats
}

